import { EducatorsSearchProvider } from "@/components/search/educators/educator-search-provider"
import {
  EducatorResultCard,
  EducatorResultContent,
  EducatorResultHeader,
  EducatorResultSpecialities,
  EducatorResultTags,
  type EducatorSearchHit,
  EducatorSearchResults,
} from "@/components/search/educators/educator-search-result"
import { EducatorSearchFacets } from "@/components/search/educators/educator-search-sidebar"
import { FullTextFilter } from "@/components/search/full-text-filter"
import { SearchTabs } from "@/components/search/search-layout"
import { SearchWorkspace } from "@/components/search/search-workspace"
import { Separator } from "@/components/ui/separator"
import { SearchUrlState } from "@/lib/redux-search/search-url-state"

export default function Page() {
  return (
    <EducatorsSearchProvider>
      <SearchUrlState />
      <SearchWorkspace>
        <SearchWorkspace.Sidebar>
          <EducatorSearchFacets />
        </SearchWorkspace.Sidebar>
        <SearchWorkspace.Content>
          <SearchTabs />
          <FullTextFilter
            filterId="educator_name"
            fields={["name"]}
            type="name"
          />
          <EducatorSearchResults ResultComponent={Result} />
        </SearchWorkspace.Content>
      </SearchWorkspace>
    </EducatorsSearchProvider>
  )
}

function Result({ result }: { result: EducatorSearchHit }) {
  return (
    <EducatorResultCard result={result}>
      <EducatorResultHeader result={result} />
      <EducatorResultContent>
        <EducatorResultSpecialities result={result} />
        <Separator />
        <EducatorResultTags result={result} />
      </EducatorResultContent>
    </EducatorResultCard>
  )
}
